import { DocsLinksSection } from 'components/docs/docs-links-section';

const DocsMcpSection = ({ section }) => <DocsLinksSection icon='server' section={section} />;

export { DocsMcpSection };
